import React, { Component } from 'react';
import "./style.scss";

// imports components
import TopNavbar from "../Topnavbar";
import BasketContent from "../BasketContent";

class Basket extends Component {
    render() {
        return (
            <div className="Basket-container">
                <TopNavbar />
                <BasketContent />
            </div>
        );
    }
}

export default Basket;
